import { useEffect, useState } from 'react';
import './article-toc.css';

export const ArticleToc = ({ sections }) => {
  const [activeId, setActiveId] = useState(sections[0]?.id);

  useEffect(() => {
    const body = document.querySelector('.article-body');
    let frame;
    const update = () => {
      frame = undefined;
      // Match the article's anchor offset, below the fixed site header.
      const nodes = sections.map(section => document.getElementById(section.id)).filter(Boolean);
      const readingLine = 120;
      let current = nodes[0]?.id;
      for (const node of nodes) {
        if (node.getBoundingClientRect().top <= readingLine) current = node.id;
        else break;
      }
      setActiveId(previous => previous === current ? previous : current);
    };
    const schedule = () => {
      if (frame === undefined) frame = window.requestAnimationFrame(update);
    };
    const observer = new ResizeObserver(schedule);
    if (body) observer.observe(body);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('hashchange', schedule);
    update();
    return () => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('hashchange', schedule);
      observer.disconnect();
      if (frame !== undefined) window.cancelAnimationFrame(frame);
    };
  }, [sections]);

  return <aside className="article-toc"><strong>В этом материале</strong>
    <nav aria-label="Содержание статьи">{sections.map(section => <a key={section.id}
      href={`#${section.id}`} aria-current={activeId === section.id ? 'location' : undefined}>
      <span>{section.title}</span>
    </a>)}</nav>
  </aside>;
};
